import { createRef } from '@wix/materializer'
import type { Ref } from '@wix/thunderbolt-types'
import type { Component } from '@wix/thunderbolt-becky-types'
import { COMPS_ROOT_NAMESPACE } from '../refs/constants'
import { NodeRefs, Unref } from '../types/refs.types'

export type WithOverrides<T> = {
	'': T
	[context: string]: T
}

export type CompNode<TDependencies, TViewerItem, TComponentNodeRefs> = {
	getDependencies: (structure: Readonly<Component>, compNodeRefs: NodeRefs<TComponentNodeRefs>) => TDependencies
	toViewItem: (
		structure: Readonly<Component>,
		data: Unref<TDependencies>
	) => TViewerItem extends WithOverrides<infer U> ? U : TViewerItem
}

export type CompNodes<T extends object> = { [key in keyof T]: CompNode<any, T[key], any> }
export const createCompNode = <TDependencies, TViewerItem, TComponentNodeRefs>(
	obj: CompNode<TDependencies, TViewerItem, TComponentNodeRefs>
) => obj

export const createCompRef = <T>(name: string, id: string, defaultValue?: T): Ref<T> =>
	createRef<T>([COMPS_ROOT_NAMESPACE, name, id], defaultValue)
